import { QueryObserverResult } from '@tanstack/react-query';
import * as React from 'react';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { SingleParentedResourceType } from '../../../resource/resource-base/SingleParentedResourceType';
import { ValidationScopes } from '../../../resource/resource-base/types';
import { EnumProperties, OverviewComponentPropertyValidationInformation } from '../../util/overviewUtils';
import { OverviewComponent } from './OverviewComponent';
import { getUseActionsByResourceType } from '../../../resource/resource-base/getUseActionsByResourceType';
import { IndirectlyVersionedArtifactResource } from '../../../resource/resource-base/artifactResourceTypes';
import { OverrideProperties } from 'type-fest';

export const SingleParentedOverviewComponent = <
    E extends string,
    R extends IndirectlyVersionedArtifactResource,
    RT extends SingleParentedResourceType,
>({
    resourceQuery,
    content,
    propertyValidationInformation,
    enumProperties,
    unusedIdParams,
    onBatchAdd,
    withAffectedMappings,
    validationScope,
    parentId,
                                                     label,
}: {
    resourceQuery: QueryObserverResult<Array<R> | null>;
    content: (id: string, displayedInOverview: boolean) => React.ReactNode;
    propertyValidationInformation: OverrideProperties<
        OverviewComponentPropertyValidationInformation,
        { resourceType: RT }
    >;
    enumProperties?: EnumProperties<E, R>;
    unusedIdParams?: { resourceType: ResourceType; parentId: string };
    onBatchAdd?: () => void;
    withAffectedMappings?: boolean;
    validationScope: ValidationScopes;
    parentId: string;
    label: string;
}) => {
    const resourceAdapterActions = getUseActionsByResourceType(propertyValidationInformation.resourceType as SingleParentedResourceType)();


    const deleteFunction = resourceAdapterActions.useDeleteResource();
    const validateResources = resourceAdapterActions.useValidateAllResourcesSingleParented(parentId, validationScope);

    return (
        <OverviewComponent
            resourceQuery={resourceQuery}
            validateResources={validateResources}
            deleteFunction={deleteFunction}
            content={content}
            propertyValidationInformation={propertyValidationInformation}
            onBatchAdd={onBatchAdd}
            enumProperties={enumProperties}
            unusedIdParams={unusedIdParams}
            withAffectedMappings={withAffectedMappings}
            validationScope={validationScope}
            label={label}
        />
    );
};


